import { Eye, EyeOff } from 'lucide-react';
import React, { useState } from 'react';

interface Props {
  ariaLabel: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  invalid?: boolean;
}

export const PasswordInput: React.FC<Props> = ({
  ariaLabel,
  value,
  onChange,
  placeholder,
  invalid = false,
}) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className="relative">
      <input
        aria-label={ariaLabel}
        className={`w-full rounded border bg-white px-3 py-2 pr-10 text-sm outline-none ${
          invalid
            ? 'border-red-500 focus:border-red-500'
            : 'border-slate-300 focus:border-[#EE7C2C]'
        }`}
        placeholder={placeholder}
        type={visible ? 'text' : 'password'}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
      <button
        aria-label={visible ? 'Ocultar senha' : 'Mostrar senha'}
        className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 transition-colors hover:text-slate-600"
        onClick={() => setVisible((current) => !current)}
        type="button"
      >
        {visible ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
};
